

















































































import Vue from 'vue'
import HitsList from './components/HitsList.vue'
import SearchInput from './components/SearchInput.vue'
import CategoryFilter from './components/CategoryFilter.vue'
import DateFilter from './components/DateFilter.vue'
import Pagination from './components/Pagination.vue'
import HitCount from './components/HitCount.vue'
import Sort from './components/Sort.vue'
import { EventBus } from './helpers/EventBus.vue'
import { ICategoryFilter, IExtraLink } from './store/state'
import { clearFilters, showSuggestions } from './store/actions'

import { scroller } from './helpers'

// Interfaces for component typechecking!
interface AppData {
	mobile: boolean
}

interface AppMethods {
	clearFilters(): void
	toTop(): void
	handleClick(event: any): void
}

interface AppComputed {
	categoryFilters: ICategoryFilter[]
	showPagination: boolean
	disableClear: boolean
	title: string
	description: string
	extraLinks: IExtraLink[]
}

interface AppProps {}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	components: {
		HitsList,
		SearchInput,
		CategoryFilter,
		DateFilter,
		Pagination,
		HitCount,
		Sort
	},
	data() {
		return {
			mobile: false
		}
	},
	created() {
		EventBus.$on('scrollToTop', () => this.toTop())
		this.mobile = window.innerWidth < 1024
	},
	computed: {
		categoryFilters() {
			return this.$store.getters.categoryFilters
		},
		showPagination() {
			return this.$store.getters.pages > 1
		},
		disableClear() {
			return !this.$store.getters.hasFilters
		},
		title() {
			return this.$store.getters.title
		},
		description() {
			return this.$store.getters.description
		},
		extraLinks() {
			return this.$store.getters.extraLinks
		}
	},
	methods: {
		clearFilters() {
			this.$store.dispatch(clearFilters({ skipSearch: false }))
		},
		toTop() {
			const anchor = this.$refs.anchor as HTMLElement
			scroller(anchor, 200, {
				onDone: () => {
					EventBus.$emit('focusFirst')
				},
				easing: 'ease-in'
			})
		},
		handleClick(event) {
			const input = this.$refs.input
			//console.log()
			
			const isClickInside = event.target.closest('#' + (input as Vue).$el.getAttribute('id'));
			if(!isClickInside) {
				this.$store.dispatch(showSuggestions(false))
			}
		}
	}
})
